










































import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import api from '../../api/v2/api'
import Exam from '../../api/v2/models/exam'

@Component({})
export default class ExamCreationFromStock extends Vue {
  stockName = ''
  exams: Exam[] = []

  forms: {
    exam: Exam
    questionCount: number
  }[] = []

  get showingExams() {
    return this.exams.filter((exam) => !this.getIsSelected(exam))
  }

  async onSearch() {
    this.exams = await api.admin.exam.index(this.stockName, Exam.TYPE_STOCK_EXAM)
  }

  select(exam: Exam) {
    if (!this.getIsSelected(exam)) {
      this.forms.push({
        exam,
        questionCount: 0
      })
    }
  }

  remove(exam: Exam) {
    if (this.getIsSelected(exam)) {
      this.forms.splice(
        this.forms.findIndex((form) => form.exam.id == exam.id),
        1
      )
    }
  }

  getIsSelected(exam: Exam) {
    return this.forms.findIndex((form) => form.exam.id == exam.id) >= 0
  }

  get totalQuestionCount() {
    let count = 0
    this.forms.forEach((form) => {
      count += parseInt(form.questionCount.toString())
    })

    return count
  }

  onSubmit() {
    api.admin.exam
      .post(
        this.forms.map((form) => {
          return { examId: form.exam.id, questionCount: form.questionCount }
        })
      )
      .then((response) => {
        location.href = location.href.split('?')[0] + `/${response.data.exam.id}`
      })
      .catch((error) => {
        alert(error.messages)
      })
  }
}
